import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem, flex } from '../../../core';

const modifiers = {
  check: () => ({
    styles: `
      label {
        margin: 0 0 .75rem;
        &:last-child {
          margin: 0;
        }
      }
    `,
  }),
  check_inline: () => ({
    styles: `
      ${flex('row', 'justify-content', 'center')};
      label {
        margin: 0 1rem 0 0;
        &:last-child {
          margin: 0;
        }
      }
    `,
  }),
};

const FormGroupStyled = styled.div.attrs({
  className: 'component__formGroup',
})`
  margin-bottom: ${rem(16)};
  ${applyStyleModifiers(modifiers)};
  a {
    font-size: ${rem(15)};
  }

  .component__Warning {
    margin-top: 0.5rem;
  }
`;

export default FormGroupStyled;
